import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    padding: '40px 0px',
    backgroundColor: theme.palette.whitePepper.main,
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  itemContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '15px',
  },

  dishWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: '25px',
    width: '100%',
    overflowX: 'auto',
    paddingRight: '25px',
  },

  dish: {
    cursor: 'pointer',
    '&:first-child': {
      marginLeft: '50px',
    },
  },

  item: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    columnGap: '20px',
  },

  imgWrapper: {
    flexShrink: 0,
    position: 'relative',
  },

  imgSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    borderRadius: '20px',
    marginBottom: '10px',
  },

  textWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '10px',
    marginBottom: '10px',
  },
});
